import Image from "next/image";
import React from "react";

const ShowMorePhotos = ({ video, images, index }) => {
  return (
    <>
      <div className="lg:hidden">
        {video && (
          <div className="absolute z-10 top-4 left-4">
            <button
              type="button"
              className="flex items-center justify-center px-4 py-2 text-sm font-medium bg-white rounded cursor-pointer"
              data-fancybox="video"
              data-src={video}
            >
              Video izle
            </button>
          </div>
        )}
        {images.length > 1 && (
          <button className="absolute z-10 flex items-center justify-center px-3 py-2 font-medium rounded-md gap-x-2 bg-[#2B3460] bottom-4 right-4 pointer-events-none">
            <div className="flex items-center justify-center w-8 h-8 bg-white rounded-lg">
              <Image
                src="/icons/right.svg"
                alt="right"
                width={16}
                height={16}
                className="-rotate-45"
              />
            </div>
            <span className="items-center justify-center text-sm text-white">
              +{images.length - 1} Fotoğraf daha
            </span>
          </button>
        )}
      </div>
      <div className="hidden lg:block">
        {index === 4 && images.length > 5 && (
          <button className="absolute inset-0 z-0 flex items-center justify-center bg-black bg-opacity-70">
            <span className="flex flex-col items-center justify-center text-sm font-normal text-white">
              <span className="text-[33px] font-normal leading-normal">
                +{images.length - 5}
              </span>
              Fotoğraf daha
            </span>
          </button>
        )}
        {index === 0 && video && (
          <div className="absolute z-10 top-4 left-4">
            <button
              type="button"
              className="flex items-center justify-center px-4 py-2 text-sm font-medium bg-white rounded"
              data-fancybox="video"
              data-src={video}
            >
              Video izle
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ShowMorePhotos;
